import { type FrontRoyalRootScope } from 'FrontRoyalAngular';
import { angularInjectorProvider } from 'Injector';
import { createOutsideModal } from 'Modal';
import { buildProjectFieldsModalProps } from './buildProjectFieldsModalProps';
import { ProjectFieldsModal } from './ProjectFieldsModal';
import {
    type CurrentUserInput,
    type ProjectFieldsModalAdapterInput,
    type SavedProjectProgress,
} from './ProjectFieldsModal.types';

type CreateOutsideProjectFieldsModalArgs = Omit<ProjectFieldsModalAdapterInput, 'currentUser'> & {
    onSaved: (saved: SavedProjectProgress) => void;
    onClose?: () => void;
};

// Mounts the React ProjectFieldsModal from Angular, outside the React tree. The admin gradebook and
// the Grading Portal evaluation modal share this one entry point.
export function createOutsideProjectFieldsModal({ onSaved, onClose, ...input }: CreateOutsideProjectFieldsModalArgs) {
    const currentUser = (angularInjectorProvider.get<FrontRoyalRootScope>('$rootScope')?.currentUser ??
        null) as CurrentUserInput;
    const adapted = buildProjectFieldsModalProps({ ...input, currentUser });

    const close = createOutsideModal(
        angularInjectorProvider.injector!,
        <ProjectFieldsModal
            {...adapted}
            onSaved={onSaved}
            closeModal={() => {
                close();
                onClose?.();
            }}
        />,
    );
}
